import "./ScheduleView.scss";
import { CloseSvg } from "../../assets/icons/Icons";
import * as animationData from "../Utils/LoaderData.json";
import Lottie from "react-lottie-player";
import { useEffect, useState } from "react";
import { hideGeneratingPopup } from "../../../../store/UnifiedControlPlaneSlice";
import { useDispatch } from "react-redux";

const systems = [
  {
    name: "Aggregate orders",
    tasks: ["Filter satellite type", "Apply priorities and time windows", "Merge conflicting demands"],
    left: "7%",
    top: "0px",
    pointLeft: "7%",
    pointTop: "66px",
  },
  {
    name: "Propagate orbits",
    tasks: ["Compute future ephemerides",
      "Creation of ground traces",
      "Evaluate access opportunities",
      "Account for perturbations & maneuvers"],
    left: "22%",
    top: "-50px",
    pointLeft: "22%",
    pointTop: "4px",
  },
  {
    name: "Allocate satellites",
    tasks: ["Match tasks to capable satellites",
      "Evaluate cloud, atmosphere & terrain",
      "Check payload & attitude feasibility"],
    left: "40%",
    top: "-85px",
    pointLeft: "40%",
    pointTop: "-28px",
  },
  {
    name: "Assign ground stations",
    tasks: ["Identify visibility windows",
      "Allocate uplink / downlink passes",
      "Enforce station availability"],
    left: "60%",
    top: "-85px",
    pointLeft: "60%",
    pointTop: "-28px",
  },
  {
    name: "Optimize selections",
    tasks: ["Enforce thermal & agility limits",
      "Balance data volume & power budgets",
      "Resolve multi - constraint conflicts"],
    left: "78%",
    top: "-60px",
    pointLeft: "78%",
    pointTop: "5px",
  },
  {
    name: "Generate schedule",
    tasks: ["Sequence commands and events",
      "Insert maneuver & settling times",
      "Produce executable timelines"],
    left: "93%",
    top: "0px",
    pointLeft: "93%",
    pointTop: "66px",
  },
];

const GeneratingSchedule = () => {
  const dispatch = useDispatch();

  const [activeIndex, setActiveIndex] = useState(0);
  const [highlightedIndexes, setHighlightedIndexes] = useState([0]);

  useEffect(() => {
    if (activeIndex >= systems.length - 2) return; // Stop when last second system is reached

    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => {
        const newIndex = prevIndex + 1;
        setHighlightedIndexes((prev) => [...prev, newIndex]); // Persist previous highlights
        return newIndex;
      });
    }, 10000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, [activeIndex]); // Depend on activeIndex so it updates

  const closeGeneratingPopup = () => {
    dispatch(hideGeneratingPopup());
  };

  return (
    <div className="generating-schedule">
      <div className="schedule-info-section">
        <div className="schedule-info-header">
          <div className="schedule-info-title">
            <div className="schedule-info-title-highlighted">
              AntarikshOne Mission Orchestrator
            </div>
            <div className="schedule-info-sub-title">
              Generating Optimized Schedule
            </div>
          </div>
          <div className="close-icon" onClick={closeGeneratingPopup}>
            <CloseSvg />
          </div>
        </div>
        <div className="schedule-info-loader">
          <Lottie
            key={"schedule-loader"}
            loop
            animationData={animationData}
            play
            style={{ width: 300, height: 300 }}
          />
        </div>

        {/* Timeline with Systems */}
        <div className="timeline-container">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="900"
            height="200"
            viewBox="0 0 708 121"
            fill="none"
          >
            <path
              d="M0.83252 120C19.7372 99.1082 45.0557 79.8436 76.1069 63.0933C149.809 23.3356 249.77 0.999996 354 1C458.23 1 558.191 23.3357 631.893 63.0934C662.944 79.8436 688.262 99.1082 707.167 120"
              stroke="white"
              stroke-width="1.5"
              className={activeIndex !== -1 ? "highlight-curve" : ""}
            />
          </svg>

          {/* System Names & Tasks Positioned Above Points */}
          {systems.map((system, index) => (
            <div
              key={index}
              className={`system ${highlightedIndexes.includes(index) ? "highlight-task-div" : ""
                }`}
              style={{ left: system.left, top: system.top }}
            >
              <div
                className={`system-header ${highlightedIndexes.includes(index) ? "highlight-task" : ""
                  }`}
              >
                {(() => {
                  const name = (system.name || "").trim();
                  const parts = name.split(/\s+/);
                  if (parts.length > 1) {
                    return (
                      <div>
                        <div>{parts[0]}</div>
                        <div>{parts.slice(1).join(" ")}</div>
                      </div>
                    );
                  }
                  return name;
                })()}
              </div>
            </div>
          ))}

          {/* Timeline Points */}
          {systems.map((system, i) => (
            <div
              key={i}
              className={`timeline-point ${highlightedIndexes.includes(i) ? "highlight-point" : ""
                }`}
              style={{ left: system.pointLeft, top: system.pointTop }}
            />
          ))}
        </div>

        {/* Footer */}
        <div className="schedule-info-footer">
          <div className="schedule-info-footer-subtitle">
            {
              systems[activeIndex]?.tasks?.map((task, i) => (
                <div key={i} style={{ display: "flex", alignItems: "flex-start" }}>
                  <span
                    style={{
                      color: "#ccf54e",
                      fontSize: "29px",
                      marginRight: "6px",
                      marginTop: "-2px",
                      lineHeight: "1"
                    }}
                  >
                    ‣
                  </span>
                  <span style={{ opacity: "0.7" }}>{task}</span>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneratingSchedule;
